import { combineReducers } from '../lib/imports';
import { showHeaderMap } from '../routing/reducer';

const notificationBarOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_NOTIFICATION_BAR_OPEN':
    case 'SET_NOTIFICATION_BAR_CLOSED':
      return !state;
    case 'SEND_PLAYER_PICKS_SUCCESS':
      return false;
    default:
      return state;
  }
};

const heatStreakPanelOpen = (state = false, action) => {
  switch (action.type) {
    case 'SET_HEATSTREAK_PANEL_OPEN':
      return !state;
    case 'SET_HEATSTREAK_PANEL_CLOSED':
      return !state;
    case 'SET_CURRENT_ROUTE':
    case 'SET_RANDOM_PLAYER_PICKS':
    case 'SET_PLAYER_TO_PICKED':
    case 'SET_SLOT_TO_OPEN':
      return false;
    default:
      return state;
  }
};

const isFetching = (state = 1, action) => {
  switch (action.type) {
    case 'SET_UI_IS_FETCHING':
      return state + 1;
    case 'SET_UI_IS_NOT_FETCHING':
      return state - 1;
    default:
      return state;
  }
};

const showNavLinks = (state = true, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
};

const showHeader = (state = true, action) => {
  switch (action.type) {
    case 'SET_CURRENT_ROUTE':
      return showHeaderMap.includes(action.resp);
    default:
      return state;
  }
};

const componentSize = (
  state = {
    notificationBar: 0,
    gameList: 0,
    picksScrollPosition: {
      withNotification: 0,
      withoutNotification: 0,
    },
  },
  action,
) => {
  switch (action.type) {
    case 'SET_ELEMENT_HEIGHT': {
      const { notificationBar, gameList } = action.resp;

      if (!notificationBarOpen || !gameList) {
        return state;
      }

      return {
        ...state,
        picksScrollPosition: {
          withNotification: notificationBar + gameList,
          withoutNotification: gameList,
        },
      };
    }
    default:
      return state;
  }
};

const isScrolling = (state = false, action) => {
  switch (action.type) {
    case 'SET_UI_SCROLLING':
      return true;
    case 'SET_UI_NOT_SCROLLING':
      return false;
    default:
      return state;
  }
};

const browserIsActive = (state = true, action) => {
  switch (action.type) {
    case 'SET_APP_FOCUS_STATE':
      return action.resp.focusState;
    default:
      return state;
  }
};

const showFooter = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
};

const isFocused = (
  state = {
    picks: false,
  },
  action,
) => {
  switch (action.type) {
    case 'SET_ELEMENT_IN_VIEW':
      return {
        ...state,
        ...action.resp,
      };
    default:
      return state;
  }
};

const hasFetchError = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return false;
    case 'FETCH_QUIZ_DATA_FAILURE':
    case 'FETCH_PLAYER_DATA_FAILURE':
    case 'FETCH_HISTORY_DATA_FAILURE':
    case 'FETCH_AUTH_FAILURE':
      return true;
    case 'FETCH_RESET':
      return false;
    default:
      return state;
  }
};

const fetchErrorCount = (state = 0, action) => {
  switch (action.type) {
    case 'SET_INCREMENT_FETCH_ERROR_COUNT':
      return action.resp;
    case 'FETCH_QUIZ_DATA_SUCCESS':
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'FETCH_HISTORY_DATA_SUCCESS':
    case 'FETCH_LEADERBOARD_DATA_SUCCESS':
      return 0;
    default:
      return state;
  }
};

const crashError = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_DATA_500_FAILURE':
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isFetching,
  componentSize,
  hasFetchError,
  isScrolling,
  notificationBarOpen,
  heatStreakPanelOpen,
  showNavLinks,
  showHeader,
  showFooter,
  isFocused,
  browserIsActive,
  fetchErrorCount,
  crashError,
});
